import { FaUserShield, FaAward, FaHandsHelping, FaGraduationCap } from "react-icons/fa";

const benefits = [
  {
    icon: <FaUserShield className="text-green-600 text-3xl" />,
    title: "Certified by Lifesaving Society",
    description: "All courses meet provincial and national aquatic training standards."
  },
  {
    icon: <FaAward className="text-yellow-500 text-3xl" />,
    title: "Expert Instructors",
    description: "Our team brings years of real-world rescue and teaching experience."
  },
  {
    icon: <FaHandsHelping className="text-blue-500 text-3xl" />,
    title: "Job Support",
    description: "We help graduates connect with employers and aquatic job openings."
  },
  {
    icon: <FaGraduationCap className="text-purple-600 text-3xl" />,
    title: "1,000+ Certified Students",
    description: "We’ve helped hundreds of students become lifeguards and instructors."
  }
];

const WhyChooseUs = () => (
  <section className="py-20 px-4 bg-blue-50">
    <h2 className="text-4xl font-bold text-center text-blue-900 mb-12">Why Choose PSA Toronto?</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto text-center">
      {benefits.map((item, index) => (
        <div key={index} className="p-6 bg-white rounded-xl shadow hover:shadow-md transition">
          <div className="mb-4">{item.icon}</div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">{item.title}</h3>
          <p className="text-sm text-gray-600">{item.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default WhyChooseUs;
